exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transdown[data-v-348ab653]{overflow:hidden;-webkit-transform:translateY(200%);transform:translateY(200%);-webkit-transition:.4s ease-in-out;transition:.4s ease-in-out}.transdown.active[data-v-348ab653]{-webkit-transform:translateY(0);transform:translateY(0)}", ""]);

// exports
